(function(){
function init(){
  var wrap=document.querySelector('.rx-blog__wrap');if(!wrap)return;
  var track=wrap.querySelector('.rx-blog__grid');if(!track||track.dataset.rxInit)return;
  var cells=Array.prototype.slice.call(track.querySelectorAll('.rx-post'));
  if(cells.length<2)return;
  track.dataset.rxInit='1';
  var prev=wrap.querySelector('.rx-blog__nav--prev'),next=wrap.querySelector('.rx-blog__nav--next');
  var dots=wrap.parentNode.querySelector('.rx-blog__dots');
  var i=0,drag=false,sx=0,sy=0,dx=0,lock=null,w=0;

  function on(){return window.innerWidth<=640}
  function width(){return wrap.getBoundingClientRect().width}
  function apply(px,anim){
    track.style.transition=anim?'transform .42s var(--ease)':'none';
    track.style.transform='translate3d('+px+'px,0,0)';
  }
  function render(anim){
    if(!on()){track.style.transform='';track.style.transition='';if(dots)dots.innerHTML='';return}
    var max=cells.length-1;if(i>max)i=max;if(i<0)i=0;
    apply(-i*width(),anim!==false);
    if(prev)prev.disabled=(i===0);
    if(next)next.disabled=(i>=max);
    if(dots){
      if(dots.children.length!==cells.length){
        dots.innerHTML='';
        for(var k=0;k<cells.length;k++){(function(k){
          var b=document.createElement('button');b.type='button';
          b.setAttribute('aria-label','Articolul '+(k+1));
          b.onclick=function(){i=k;render()};
          dots.appendChild(b);
        })(k)}
      }
      Array.prototype.forEach.call(dots.children,function(b,k){b.classList.toggle('is-on',k===i)});
    }
  }
  if(prev)prev.onclick=function(){i--;render()};
  if(next)next.onclick=function(){i++;render()};

  function down(x,y){if(!on())return;drag=true;sx=x;sy=y;dx=0;lock=null;w=width();track.style.transition='none';track.classList.add('is-grabbing')}
  function move(x,y,e){
    if(!drag)return;
    var mx=x-sx,my=y-sy;
    if(lock===null){
      if(Math.abs(mx)<5&&Math.abs(my)<5)return;
      lock=Math.abs(mx)>Math.abs(my)?'x':'y';
    }
    if(lock==='y'){drag=false;track.classList.remove('is-grabbing');apply(-i*w,true);return}
    if(e&&e.cancelable)e.preventDefault();
    dx=mx;
    var base=-i*w,p=base+dx;
    if(i===0&&dx>0)p=base+dx*.35;
    if(i===cells.length-1&&dx<0)p=base+dx*.35;
    apply(p,false);
  }
  function up(){
    if(!drag)return;drag=false;track.classList.remove('is-grabbing');
    if(lock!=='x'){apply(-i*w,true);return}
    /* prag mic: 12% din lățime sau 40px */
    if(Math.abs(dx)>w*.12||Math.abs(dx)>40)i+=dx<0?1:-1;
    render();
  }

  track.addEventListener('touchstart',function(e){down(e.touches[0].clientX,e.touches[0].clientY)},{passive:true});
  track.addEventListener('touchmove',function(e){move(e.touches[0].clientX,e.touches[0].clientY,e)},{passive:false});
  track.addEventListener('touchend',up,{passive:true});
  track.addEventListener('touchcancel',up,{passive:true});
  track.addEventListener('mousedown',function(e){if(e.button!==0)return;down(e.clientX,e.clientY);e.preventDefault()});
  window.addEventListener('mousemove',function(e){if(drag)move(e.clientX,e.clientY,e)});
  window.addEventListener('mouseup',up);
  track.addEventListener('click',function(e){if(Math.abs(dx)>8){e.preventDefault();e.stopPropagation()}},true);
  track.addEventListener('dragstart',function(e){e.preventDefault()});

  var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){render(false)},150)});
  render(false);
}
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
document.addEventListener('shopify:section:load',init);
})();